<template lang="pug">
    .font-mullerBlack(:class="getTextColor()" class="text-4xl 1024:text-6xl mb-3")
        slot
            span ПОЗДРАВЛЯЕМ!
</template>

<script>
//Store
import { RootGetterTypes } from '@/store/types';

export default {
    name: "Greeting",
    computed: {
        SETTINGS() {
            return this.$store.getters[`${RootGetterTypes.GetSettings}`]
        },
    },
    methods: {
        getTextColor() {
            return this.SETTINGS.main_color
        },
    }
}
</script>